/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import routes from './routes';

const GuardedRoute = ({
  component: Component,
  auth,
  isProfileFinished,
  userRole,
  restrictToRoles,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (!auth) {
          return <Redirect to={routes.login.link} />;
        }
        if (auth && isProfileFinished !== null && !isProfileFinished) {
          return <Redirect to={routes.finishProfile.link} />;
        }
        // If role restrictions are specified, enforce them
        if (restrictToRoles && userRole && !restrictToRoles.includes(userRole)) {
          // Players trying to access coach routes → redirect to player inbox
          if (userRole === 'player') {
            return <Redirect to="/player/inbox" />;
          }
          return <Redirect to={routes.login.link} />;
        }
        // Render component immediately (even while isProfileFinished is still loading)
        // The component handles its own loading state
        return <Component {...props} />;
      }}
    />
  );
};

export default GuardedRoute;
